import io from 'socket.io-client';
import feathers from '@feathersjs/client';
import auth from '@feathersjs/authentication-client';
import { applicationConfigStore } from '../stores/applicationConfigStore';
import { get } from 'svelte/store';
// TS doesn't know how to handle get at the moment
const url = get(applicationConfigStore).apiUrl;
const socket = io(url);
const app = feathers()
    .configure(feathers.socketio(socket))
    .configure(auth({
    storage: window.localStorage,
}));
socket.on('connect', () => {
    console.log('Connected to websocket server...');
});
export default app;
